<div>
  <label class="text-uppercase input-label" for="{{selectId}}-label" *ngIf="label !== null">
    {{label}}
    <span class="text-danger" *ngIf="required"> *</span>
  </label>

  <ng-select #wfmSelect
             [id]="selectId"
             [items]="items"
             [selectOnTab]="true"
             [placeholder]="placeHolder"
             [clearable]="false"
             class="wfm-select"
             [virtualScroll]="true"
             (change)="updateValue()"
             labelForId="{{selectId}}-label"
             bindLabel="label"
             [loading]="showLoading"
             [disabled]="disabled"
             [title]="displayText(selectedItem) || placeHolder"
             loadingText="Loading"
             [tabindex]="-1"
             [(ngModel)]="selectedItem"
             notFoundText="{{'dropdown.no.items' | translate}}">
    <ng-template ng-label-tmp let-item="item">

      {{displayText(item)}}
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="wfm-select-option {{item.styleClass}}" title="{{displayText(item)}}">{{displayText(item)}}</div>

    </ng-template>

  </ng-select>

</div>
